import React from "react";
import { useDispatch } from "react-redux";

import t from "../../../../Common/utils/translation/translator";
import { tData } from "../../../../Common/utils/translation/dataUtils";

const AxisSelectionFilterMiddleSection = ({
  cartesianPossibleFiltersValues,
  dependencies,
  setCartesianFilters,
  cartesianFilters
}) => {
  const dispatch = useDispatch();

  const handleMechanicalDriveChange = (event) => {
    const selectedDriveType = event.target.value;

    const driveTypeArray = selectedDriveType === "" ? undefined : [selectedDriveType];
    // Update the mechanicalDrive property within the cartesianFilters object
    const updatedAxisFilter = {
      ...cartesianFilters.axisFilter,
      driveType: driveTypeArray
    };
    // Dispatch the action with the updated cartesianFilters
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        axisFilter: updatedAxisFilter
      })
    );
  };

  const handleAxisProfileSizeChange = (event) => {
    const selectedAxisProfileSize = event.target.value;
    // Wrap the selectedAxisProfileSize in an array
    const axisProfileSizeArray = selectedAxisProfileSize === "" ? undefined : [selectedAxisProfileSize];
    // Update the axisProfileSize property within the axisProfileFilter object
    const updatedAxisFilter = {
      ...cartesianFilters.axisFilter,
      profileDimension: axisProfileSizeArray
    };
    // Dispatch the action with the updated cartesianFilters
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        axisFilter: updatedAxisFilter
      })
    );
  };

  const handleGuideTypeChange = (event) => {
    const selectedGuideType = event.target.value;
    // Wrap the selectedGuideType in an array
    const GuideTypeArray = selectedGuideType === "" ? undefined : [selectedGuideType];
    // Update the GuideType property within the axisProfileFilter object
    const updatedGuideFilter = {
      ...cartesianFilters.guideFilter,
      guideType: GuideTypeArray
    };
    // Dispatch the action with the updated cartesianFilters
    dispatch(
      setCartesianFilters({
        ...cartesianFilters,
        guideFilter: updatedGuideFilter
      })
    );
  };

  return (
    <div className="flex flex-col flex-1 space-y-3">
      <div>
        <div className="mb-2 font-semibold text-gray-700">
          {t("cartesian.ui.axis_selection.mechanical_drive_elements")}
        </div>
        <div>
          <select
            className="w-full mb-1 text-sm py-1 px-2 cursor-pointer text-gray-600 border-gray-300"
            name="mechanicalDrive"
            id="mechanicalDrivers"
            value={cartesianFilters?.axisFilter?.driveType?.[0] || ""}
            onChange={handleMechanicalDriveChange}
          >
            <option value="">{t("cartesian.ui.axis_selection.all_mechanical_drive")}</option>
            {cartesianPossibleFiltersValues?.axis?.driveType?.map((mechanicalDriveElt) => {
              const optionDisabled = !dependencies?.driveType?.includes(mechanicalDriveElt);
              return (
                <option
                  className={!optionDisabled && "font-bold"}
                  key={mechanicalDriveElt}
                  value={mechanicalDriveElt}
                  disabled={optionDisabled}
                >
                  {tData("axis_type", "mechanical_drive_element", mechanicalDriveElt)}
                </option>
              );
            })}
          </select>
        </div>
      </div>

      <div>
        <div className="mb-2 font-semibold text-gray-700">{t("cartesian.ui.axis_selection.profile_size")}</div>
        <div>
          <select
            className="w-full mb-1 text-sm py-1 px-2 cursor-pointer text-gray-600 border-gray-300"
            name="profileSize"
            id="profileSize"
            value={cartesianFilters?.axisFilter?.profileDimension?.[0] || ""}
            onChange={handleAxisProfileSizeChange}
          >
            <option value="">{t("cartesian.ui.axis_selection.all_profile_size")}</option>
            {cartesianPossibleFiltersValues?.axis?.profileDimension
              ?.filter((profileDimensionElt) => profileDimensionElt !== null)
              ?.map((profileDimensionElt) => {
                const optionDisabled = !dependencies?.profileDimension?.includes(profileDimensionElt);
                return (
                  <option
                    className={!optionDisabled && "font-bold"}
                    key={profileDimensionElt}
                    value={profileDimensionElt}
                    disabled={optionDisabled}
                  >
                    {profileDimensionElt}
                  </option>
                );
              })}
          </select>
        </div>
      </div>

      <div>
        <div className="mb-2 font-semibold text-gray-700">{t("cartesian.ui.axis_selection.guide_type")}</div>
        <div>
          <select
            className="w-full mb-1 text-sm py-1 px-2 cursor-pointer text-gray-600 border-gray-300"
            name="guideType"
            id="guideType"
            value={cartesianFilters?.guideFilter?.guideType?.[0] || ""}
            onChange={handleGuideTypeChange}
          >
            <option value="">{t("cartesian.ui.axis_selection.all_guide_type")}</option>
            {cartesianPossibleFiltersValues?.guide?.guideType
              ?.filter((guideTypeElt) => guideTypeElt !== null)
              ?.map((guideTypeElt) => {
                const optionDisabled = !dependencies?.guideType?.includes(guideTypeElt);
                return (
                  <option
                    className={!optionDisabled && "font-bold"}
                    key={guideTypeElt}
                    value={guideTypeElt}
                    disabled={optionDisabled}
                  >
                    {tData("axis_type", "guide_type", guideTypeElt)}
                  </option>
                );
              })}
          </select>
        </div>
      </div>
    </div>
  );
};

export default AxisSelectionFilterMiddleSection;
